import React, { useEffect, useState } from "react";
import { Plus, Download } from "lucide-react";
import { useCrm } from "../../pages/crm/CrmApp";
import { money, QSTATUS, fmtDate } from "../../lib/crmApi";
import { API } from "../../api";
import { QuoteEditor } from "./QuoteEditor";

const COLORS = { borrador: "bg-slate-100 text-slate-600", enviada: "bg-blue-100 text-blue-700", aceptada: "bg-emerald-100 text-emerald-700", rechazada: "bg-red-100 text-red-600" };

export const Quotes = () => {
  const { api } = useCrm();
  const [list, setList] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [edit, setEdit] = useState(null);
  const [filter, setFilter] = useState("");
  const load = () => api("/quotes").then(setList);
  useEffect(() => {
    load();
    api("/contacts").then(setContacts);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const shown = (list || []).filter((q) => !filter || q.status === filter);
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900">Cotizaciones</h1>
        <button onClick={() => setEdit({ new: true })} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2.5 text-sm font-semibold text-white shadow" style={{ background: "var(--crm)" }} data-testid="crm-new-quote"><Plus className="h-4 w-4" /> Nueva</button>
      </div>
      <div className="flex gap-2 overflow-x-auto">
        {[["", "Todas"], ...Object.entries(QSTATUS)].map(([k, l]) => (
          <button key={k || "all"} onClick={() => setFilter(k)} className={`shrink-0 rounded-full border px-3.5 py-1.5 text-xs font-medium ${filter === k ? "border-transparent text-white" : "border-slate-200 bg-white text-slate-600"}`} style={filter === k ? { background: "var(--crm)" } : {}} data-testid={`crm-qfilter-${k || "all"}`}>{l}</button>
        ))}
      </div>
      {list && !shown.length && <p className="py-12 text-center text-sm text-slate-400" data-testid="crm-quotes-empty">No hay cotizaciones.</p>}
      <div className="space-y-2">
        {shown.map((q) => (
          <div key={q.id} className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3.5" data-testid={`crm-quote-row-${q.id}`}>
            <button className="min-w-0 flex-1 text-left" onClick={() => setEdit({ quote: q })}>
              <p className="truncate text-sm font-semibold text-slate-900">{q.number} · {q.contact_name}</p>
              <p className="text-xs text-slate-500">{fmtDate(q.created_at)} · {q.seller_name}</p>
            </button>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${COLORS[q.status]}`}>{QSTATUS[q.status]}</span>
            <span className="text-sm font-bold text-slate-900">{money(q.total)}</span>
            <a href={`${API}/crm/q/${q.public_token}.pdf`} target="_blank" rel="noreferrer" className="rounded-lg p-2 text-slate-500 hover:bg-slate-100" data-testid={`crm-quote-pdf-${q.id}`}><Download className="h-4 w-4" /></a>
          </div>
        ))}
      </div>
      <QuoteEditor open={!!edit} quote={edit?.quote} contacts={edit?.new ? contacts : null} onClose={() => setEdit(null)} onSaved={load} />
    </div>
  );
};
